import { render, staticRenderFns } from "./SecondaryAnnouncements.vue?vue&type=template&id=394c6a79&scoped=true"
import script from "./SecondaryAnnouncements.vue?vue&type=script&lang=js"
export * from "./SecondaryAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./SecondaryAnnouncements.vue?vue&type=style&index=0&id=394c6a79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c6a79",
  null
  
)

export default component.exports